import { parseColumnWidth } from "../utils";

function normalizeAlign(align) {
  align = String(align || "").trim().toLowerCase();
  if (align === "left" || align === "center" || align === "right") {
    return align;
  }
  return null;
}

export default function makeModuleSections(
  modules,
  { ignoreBackgrounds = false } = {},
) {
  if (!modules?.length) return [];
  modules = modules
    .map(({ columnWidth, ...module }) => ({
      colspan: parseColumnWidth(columnWidth),
      ...module,
    }))
    .filter(({ module, hidden }) => module && !hidden);
  if (!modules?.length) return [];
  let rows = [];
  let currentSection = {
    modules: [],
    background: (!ignoreBackgrounds && modules[0].background) || "transparent",
    align: null,
  };
  let currentSectionColspan = 0;
  for (let module of modules) {
    const colspan = module.colspan || 12;
    const moduleAlign = normalizeAlign(module.align);
    const hasAlignMismatch =
      currentSection.modules.length > 0 &&
      moduleAlign &&
      currentSection.align &&
      moduleAlign !== currentSection.align;
    if (
      colspan + currentSectionColspan > 12 ||
      hasAlignMismatch ||
      ((!ignoreBackgrounds && module.background) || "transparent") !==
        currentSection.background
    ) {
      rows.push(currentSection);
      currentSection = {
        modules: [],
        background: (!ignoreBackgrounds && module.background) || "transparent",
        align: null,
      };
      currentSectionColspan = 0;
    }
    currentSection.modules.push(module);
    if (!currentSection.align && moduleAlign) {
      currentSection.align = moduleAlign;
    }
    currentSectionColspan += colspan;
  }
  if (currentSection.modules.length) {
    rows.push(currentSection);
  }
  return rows;
}
